/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

var reCaptchaManager = require('../modules/users/recaptcha.js');

Odigeo.defineWidget('share_selection', Odigeo.Widget.extend({
    modelClass: require('../modules/models/share_selection'),

    viewClass: require('../modules/views/share_selection'),

    init: Odigeo._.noop,

    reset: function() {
        this.model.reset.apply(this.model, arguments);
    },

    setShareSelectionEl: function() {
        this.view.setShareSelectionEl.apply(this.view, arguments);
    },

    initLauncher: function() {
        this.view.initLauncher.apply(this.view, arguments);
    },

    toggleLauncher: function() {
        this.view.toggleLauncher.apply(this.view, arguments);
    },

    renderCaptcha: function() {
        if (this.model.get('captchaEnabledWithInit')) {
            this.enableCaptcha();
        } else {
            this.model.set('captchaEnabled', true);
        }
    },

    enableCaptcha: function() {
        if (!this.model.get('reCaptchaWidgetId')) {
            this.model.set('reCaptchaWidgetId', reCaptchaManager.gRecaptchaRender(
                this.view.$cachedSelectors.captchaWrapper.get(0),
                Odigeo._.bind(this.view.reCaptchaExecutionCallback, this.view),
                this.options.reCaptchaSiteKey));
            this.view.$cachedSelectors.captchaWrapper.removeClass('odf-hidden');
        }
    },
}));
